import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { pkr } from "@/lib/site";
import { useCart } from "@/lib/cart";

export const FragranceCard = ({ f, index = 0 }) => {
  const { add } = useCart();
  return (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay: (index % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
  >
    <Link to={`/fragrance/${f.slug}`} data-testid={`fragrance-card-${f.slug}`} className="group block">
      <div className="relative overflow-hidden bg-[#DDD3C1] border border-[#2B2118]/[0.07]" style={{ aspectRatio: "1408/1097" }}>
        <img
          src={f.image}
          alt={f.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
        />
        <div
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-black/70 backdrop-blur-[2px] flex flex-col justify-end p-6"
        >
          <div className="space-y-3 text-[13px]">
            {[["Top", f.notes?.top], ["Heart", f.notes?.heart], ["Base", f.notes?.base]].map(([k, v]) => (
              <div key={k}>
                <span className="text-[10px] tracking-[0.3em] uppercase" style={{ color: f.hex === "#171514" || f.hex === "#272523" ? "#C6A87C" : f.hex }}>{k}</span>
                <p className="text-[#F4F1EB]/90 mt-0.5">{(v || []).join(" · ")}</p>
              </div>
            ))}
          </div>
          {!f.sold_out && (
            <button
              data-testid={`card-add-to-cart-${f.slug}`}
              onClick={(e) => { e.preventDefault(); add({ slug: f.slug, name: f.name, price: f.price, image: f.image }); toast.success(`${f.name} added to your cart.`); }}
              className="mt-5 w-full rounded-full bg-[#C6A87C] text-[#191512] py-3 text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-[#E8DCC5] transition-colors duration-300"
            >
              Add to Cart — {pkr(f.price)}
            </button>
          )}
        </div>
        <div className="absolute top-4 left-4 flex gap-2">
          <div className="text-[10px] tracking-[0.3em] uppercase font-medium text-[#EAD9B8] bg-[#2B2118]/70 backdrop-blur px-3 py-1.5 border border-[#EAD9B8]/25">{f.gender}</div>
          {f.sold_out && <div data-testid={`sold-out-badge-${f.slug}`} className="text-[10px] tracking-[0.3em] uppercase text-[#C6A87C] bg-black/60 backdrop-blur px-3 py-1.5 border border-[#C6A87C]/40">Sold Out</div>}
        </div>
      </div>
      <div className="flex items-baseline justify-between mt-5">
        <h3 className="font-display text-xl text-[#2B2118] group-hover:text-[#8F6B3A] transition-colors duration-300">{f.name}</h3>
        <p className="text-sm font-medium text-[#5C4A33]">{pkr(f.price)}</p>
      </div>
      <p className="text-xs text-[#6E6151] mt-1">{f.tagline}</p>
    </Link>
  </motion.div>
  );
};
